<h1>Useful Links</h1>

<div class="p-grid">
  <div class="p-col p-lg-4 p-xl-3">
    <p-card>
      <ul>
        <li>
          <a href="https://adfs.propak.com/adfs/portal/updatepassword/">Password Reset</a>
        </li>
        <li>
          <a href="https://www.mypropak.com/">MyPropak</a>
        </li>
        <li>
          <a href="https://propakco.sharepoint.com/search/Pages/directory.aspx">Employee Directory</a>
        </li>
        <li>
          <a href="https://propakco.sharepoint.com/:f:/r/sites/PropakCorporationTeam/Shared%20Documents/General/Policies%20and%20Procedures?csf=1&web=1&e=sgeJYH">
            Policies and Procedures
          </a>
        </li>
      </ul>
    </p-card>
  </div>
</div>
